import React, { Component } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
export class AuthenticateFace extends Component {
  loadLivenessCheck() {
    window.ConfiaApp.onAuthenticateFaceSuccess(this.props.onSuccess);
    window.ConfiaApp.onAuthenticateFaceError(this.props.onError);
    window.ConfiaApp.loadLivenessCheck(this.props.externalDatabaseRefID, this.props.identifier, Cookies.get("XSRF-TOKEN"), this.props.frontUuid);
  }

  render() {
    return <div>{this.loadLivenessCheck()}</div>;
  }
}

AuthenticateFace.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  externalDatabaseRefID: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  frontUuid: PropTypes.number.isRequired,
};

export default AuthenticateFace;
